//
// AgeGateTPActions
//
// This function component is responsible for all the external (T)hird (P)arty
// Actions required by this app. The third parties being
// a. Cookies:
//    - setRouteToLocatorCookie - This method assists with setting
//        the `hasVerifiedRouteToLocatorAgeGate` cookie required for the
//        quebec `route to locator` flow
//    - setCookie - This method assists with setting the
//        `hasVerifiedAgeGate` and `hasVerifiedWarrantyAgeGate` cookies
//        for our regular and warranty age gate workflows respectively
// b. Window Urls:
//    - routeToLocatorUrl - This method assists with routing the user to the
//        `/locator` url for the quebec `route to locator` workflow
//    - updateLanguage - This method assists us with changing the locale
//        for the user. This is currently used for Canada and Switzerland
// c. Api:
//    - statePricing - We need to let the backend service know as to which state
//        the user resides in, when in the US. This is required for excise
//        tax pricing purposes. This method assists with letting juulio
//        know about the users state via Api
//

import { localisedPath } from 'common/url_locale_helper';

export const AgeGateTPActions = ({
  bugsnagClient,
  windowLocation,
  api,
  cookie,
}) => {
  const setToThirtyDays = cookieKey => {
    return cookie.set(cookieKey, true, {
      expires: 30,
    });
  };

  return {
    setRouteToLocatorCookie: () => {
      return setToThirtyDays('hasVerifiedRouteToLocatorAgeGate');
    },
    setCookie: ageGateUIPolicy => {
      return setToThirtyDays(
        ageGateUIPolicy.isWarrantyAgeGate()
          ? 'hasVerifiedWarrantyAgeGate'
          : 'hasVerifiedAgeGate'
      );
    },
    routeToLocatorUrl: () => {
      if (!windowLocation.pathname.includes('locator')) {
        windowLocation.assign(localisedPath(`/locator`));
      }
    },
    updateLanguage: language => {
      const oldString = windowLocation.search;
      const newString = windowLocation.search.replace(
        /language=[^&$]*/i,
        `language=${language}`
      );

      if (oldString === newString) {
        return (windowLocation.search += `&language=${language}`);
      }

      return (windowLocation.search = newString);
    },
    // 1. Call api with state
    // 2. If successful,
    //      if pricing state, refresh with different url
    //    Close Modal
    // 3. If unsuccessful,
    //      report to bugsnag
    //    Dont close modal
    statePricing: stateCode => {
      const handleStatePricingTriggerSuccess = function(response) {
        if (response.state_has_pricing && windowLocation) {
          windowLocation.search += `&ag=${response.state_abbr}`;
        }
      };
      const handleStatePricingTriggerFailure = function(error) {
        bugsnagClient && bugsnagClient.notify(error);
      };

      return api
        .sessionStateAbbr(stateCode)
        .then(response => handleStatePricingTriggerSuccess(response))
        .catch(error => handleStatePricingTriggerFailure(error));
    },
  };
};
